import { getUser } from '@simplywallst/services';

export const queryKey = 'getUser';

export async function queryFn() {
  try {
    const response = await getUser();
    const { country_iso } = response.data.data;
    return country_iso;
  } catch (error) {
    console.error(error);
  }
  return 'US';
}
